import React from 'react';
import { Box, Button, FormHelperText, FormLabel, Grid, Stack, TextField } from '@mui/material';
import { Add } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { useFormikContext } from 'formik';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useFormikHelper } from '@/hooks/useFormikHelper';
import { InstantClientSelect } from '@/components/selects/ClientSelect';
import { openDialog } from '@/features/dialog/dialogSlice';
import { VIEW_TYPES } from '@/features/config/helper';
import { SEARCH_CLIENT_HELP_TEXT } from '@/utils/helperText';
import { CLIENT_ID, CLIENT_NAME, OTHER_INFO } from '../validationSchema';

export const SearchClient = ({ disabled }) => {
	const { values, setFieldValue } = useFormikContext();
	const { getError, getErrorMessage } = useFormikHelper();

	const dispatch = useDispatch();
	const location = useLocation();

	const existingClient = location?.state?.client ?? {};
	const usingExistingClient = Object.keys(existingClient).length > 0;

	return (
		<>
			<Grid size={12}>
				<Stack width='100%'>
					<FormLabel required>
						{usingExistingClient ? 'Existing Client' : 'Search Client'}
					</FormLabel>
					<Stack width='100%'>
						<Stack
							direction='row'
							justifyContent={'space-between'}
							alignItems={'center'}
							spacing={2}
						>
							<Stack width='100%'>
								{usingExistingClient ? (
									<TextField
										fullWidth
										defaultValue={existingClient?.name}
										slotProps={{ input: { readOnly: true } }}
									/>
								) : (
									<InstantClientSelect
										clientId={values[CLIENT_ID]}
										clientName={values[CLIENT_NAME] ?? ''}
										disabled={disabled}
										setClient={(client) => {
											if (client) {
												console.log(
													'Here is the selected client: ',
													client,
												);
												setFieldValue(CLIENT_ID, client.id);
												setFieldValue(CLIENT_NAME, client.name);
												setFieldValue(OTHER_INFO, client.description);
											} else {
												setFieldValue(CLIENT_ID, null);
												setFieldValue(CLIENT_NAME, '');
												setFieldValue(OTHER_INFO, '');
											}
										}}
									/>
								)}
							</Stack>

							<Box>
								<Button
									component='label'
									variant='contained'
									startIcon={usingExistingClient ? <EditIcon /> : <Add />}
									sx={{ width: 'max-content' }}
									onClick={() =>
										dispatch(
											openDialog({
												dialogName: 'clientDialog',
												data: {
													isProspect:
														existingClient?.isProspect ||
														existingClient?.clientRow?.isProspect,
													view: usingExistingClient
														? VIEW_TYPES.update
														: VIEW_TYPES.create,
													...(usingExistingClient && {
														clientId: existingClient?.clientId,
													}),
												},
											}),
										)
									}
								>
									{`${usingExistingClient ? 'Edit' : 'New'} Client`}
								</Button>
							</Box>
						</Stack>

						<FormHelperText error={getError(CLIENT_ID)}>
							{getErrorMessage(CLIENT_ID)}
						</FormHelperText>
						<FormHelperText>{SEARCH_CLIENT_HELP_TEXT}</FormHelperText>
					</Stack>
				</Stack>
			</Grid>
		</>
	);
};
